import React from 'react';

const SelectTrigger = ({ children }) => {
  return <div className="p-2 border rounded">{children}</div>;
};

SelectTrigger.displayName = 'SelectTrigger';
export default SelectTrigger;
